module.exports = __webpack_public_path__ + "static/tomato@2x-f275e59cac15f89822145c1cf5ba9784.png";